module.exports = __webpack_public_path__ + "img/img89.c812d9d8.png";